export const defaultSameValueJoystickDebounce = 0.5;
export const defaultNewValueJoystickDebounce = 0.1;
export const lowSameValueJoystickDebounce = 0.1;
export const lowNewValueJoystickDebounce = 0.05;
